module.exports = __webpack_public_path__ + "media/images/undraw/reserve/profile-9dde60e28a413a2f10a81e8091137f10.png";